<script>
export default {
    name: "IconSeasonalPromotion"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 540.7 467.5">
        <path
            d="M289.6,252.5l22.2,20.7c-7.2,8.8-16.1,15.5-26.6,20-10.6,4.6-22.4,6.9-35.5,6.9s-24.1-2.2-34.8-6.7c-10.7-4.5-19.8-10.8-27.3-19-7.5-8.2-12.9-17.7-16.2-28.5h-24.4v-18.1h21.1c-.1-1.3-.2-3.2-.2-5.8s0-4.5.2-5.8h-21.1v-18.1h24.4c3.3-10.8,8.7-20.3,16.2-28.5,7.5-8.2,16.6-14.5,27.3-19s22.3-6.7,34.8-6.7,24.9,2.3,35.5,6.9c10.6,4.6,19.4,11.2,26.6,19.8l-22.2,20.7c-10.5-11.8-23.2-17.7-38.2-17.7s-18,2.2-25.4,6.5-13.2,10.3-17.2,17.9h54.5v18.1h-59.9c-.1,1.3-.2,3.2-.2,5.8s0,4.5.2,5.8h59.9v18.1h-54.6c4,7.6,9.8,13.6,17.2,17.9,7.5,4.3,16,6.5,25.4,6.5,15.1,0,27.8-6,38.2-17.9h0Z"
            fill="white"/>
        <path
            d="M483.2,60.1c40.2,23.8,87.3,116.3,33.2,146.8-45.7,25.8-112.7-21.5-138.8-58.2-6.3-8.9-10.4-21.3-16-28.4-3.8-4.8-9-6.2-13.4-12.7-22.7-34.4,30.1-61.8,47.2-31.5,10.3,18.2-2.1,29,0,36.4,3.9,13.9,34.9,43.6,47.8,51.7,38.5,24.3,82,25.4,56.2-32.7-2.4-5.5-16.2-24.1-16.2-25.6v-45.7h0Z"
            fill="white"/>
        <path
            d="M462,43.3C458.8,20.2,431.3.2,408.7,0c-35.4-.3-94.4,5.9-130.6,10.5-45.8,5.8-59.5,27.2-91.5,57.4C122.3,128.6,61.9,194.1,0,257.3l207.6,210.2,233.9-236.2c7.8-10-21.1-21.6-27.6-17.3l-204,206.4L44.4,257.3,244.1,57.4c11.2-9.1,26.7-13.5,43.7-15.8v-.3c-.1,0,100.8-7.8,100.8-7.8,4.2-.5,8-.8,11.5-.9l2-.2-.2.2c52.4.5,16.8,59.4,26.9,93.5,1.3,4.5,25.4,26,28.2,22.7-.6-33.3,9.6-72.8,5-105.5h0Z"
            fill="white"/>
    </svg>
</template>